import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'

interface ExceptionStatusBadgeProps {
  status: string
}

export function ExceptionStatusBadge({ status }: ExceptionStatusBadgeProps) {
  const { t } = useTranslation('conversations')

  switch (status) {
    case 'resolved':
      return <Badge variant="outline" className="text-green-600 border-green-300">{t('errors.status.resolved')}</Badge>
    case 'ignored':
      return <Badge variant="secondary">{t('errors.status.ignored')}</Badge>
    default:
      return <Badge variant="destructive">{t('errors.status.unresolved')}</Badge>
  }
}
